import { DataGrid, DataGridLayout } from '@verantos-dev/shared-components';

import { useConceptGroupDataGridFetch } from '../hooks/useConceptGroupDataGridFetch';
import { useConceptGroups } from '../hooks/useConceptGroups';

export const ConceptGroupsGrid = () => {
  const { columns, getRowId, sortModel, columnVisibilityModel } = useConceptGroups();

  return (
    <DataGridLayout id="concept-groups-list-content">
      <DataGrid
        id="concept-groups-grid"
        mode="client"
        getRowId={getRowId}
        columns={columns}
        useFetchDataGridData={useConceptGroupDataGridFetch}
        disableSearchParamSync
        initialState={{
          sorting: {
            sortModel,
          },
          columns: {
            columnVisibilityModel,
          },
        }}
        onCellClick={() => {
          // TODO: @jason.ko - Implement on cell click for concept group view
        }}
      />
    </DataGridLayout>
  );
};
